import styled from 'styled-components';

export const PageContainer = styled.div`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background: #fff;
`;

export const MainContent = styled.main`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 0 20px;
	max-width: 1200px;
	margin: 0 auto;
	width: 100%;
`;
